import React from 'react';
import { CardTitle } from 'material-ui/Card';
import withWidth from 'material-ui/utils/withWidth';
// import {AppBarMobile} from 'admin-on-rest';
import AppBarMobile from './AppBarMobile';

const ViewTitle = ({ title, width }) =>
    width === 1 ? (
        <AppBarMobile title={title}/>
    ) : (
        <CardTitle title={title} className="title" style={{paddingBottom: 0}}/>
    );

export default withWidth()(ViewTitle);


// WEBPACK FOOTER //
// ./src/components/appbar/ViewTitle.js